import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'Nomiswap',
  description: 'Become a liquidity provider and receive NMX tokens every second.',
  image: 'https://nomiswap.io/logo.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath = ''

  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/liquidity/find')) {
    basePath = '/find'
  } else if (path.startsWith('/liquidity/add')) {
    basePath = '/add'
  } else if (path.startsWith('/liquidity/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/farms/create')) {
    basePath = '/farms/create'
  } else if (path.startsWith('/farms/community')) {
    basePath = '/farms/community'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('Nomiswap')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('Nomiswap')}`,
      }
    case '/add':
      return {
        title: `${t('Add liquidity')} | ${t('Nomiswap')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove liquidity')} | ${t('Nomiswap')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('Nomiswap')}`,
      }
    case '/find':
      return {
        title: `${t('Import pool')} | ${t('Nomiswap')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('Nomiswap')}`,
      }
    case '/farms/create':
      return {
        title: `${t('Create custom farm')} | ${t('Nomiswap')}`,
      }
    case '/farms/community':
      return {
        title: `${t('Custom farms')} | ${t('Nomiswap')}`,
      }
    case '/pools':
      return {
        title: `${t('Launchpools')} | ${t('Nomiswap')}`,
      }
    case '/dashboard':
      return {
        title: `${t('Dashboard')} | ${t('Nomiswap')}`,
      }
    case '/referrals':
      return {
        title: `${t('Referral program')} | ${t('Nomiswap')}`,
      }
    case '/bonuses':
      return {
        title: `${t('Rewards')} | ${t('Nomiswap')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('Nomiswap Info & Analytics')}`,
        description: 'View statistics for Nomiswap exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('Nomiswap Info & Analytics')}`,
        description: 'View statistics for Nomiswap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('Nomiswap Info & Analytics')}`,
        description: 'View statistics for Nomiswap exchanges.',
      }
    default:
      return null
  }
}
